import { Subject } from 'rxjs';
import isEqual from 'lodash.isequal';
import Analytics from '@withlocals/withlocals-analytics';

import { ExperienceSource } from 'model/IExperience';
import omit from 'lodash.omit';
import { WlWindow } from 'typings/globals/cordova';
import { EventParams, EventContext, EventType } from '~/types/Analytics';
import { trekkerFactory } from "react-trekker";
import { ga4EcommerceListener, ga4CookieConsentEventListener } from '../trackers/tools/ga4/ga4';
import { BusinessEventSource } from '../trackers/businessLayer';
import { trekkerAdapter } from '../trackers/businessLayerAdapter';
import { plausibleHandler } from "../trackers/tools/plausible/handler";
import { isCordova } from "utils/platform";

export const {useTrekker, WithTrekkerContext, WithTrekker, Trek, TrekkerProvider, TrekkerHoc, useOnTrekkerMount, bus} = trekkerFactory<EventContext, EventType>()
const businessEventSource = new BusinessEventSource()
bus.addCatchAllEventListener( (evt: any) =>{
  console.log("[TREKKER] event", evt.eventName, evt.context)
} )
bus.addCatchAllEventListener( trekkerAdapter(businessEventSource) )
bus.addCatchAllEventListener( ga4CookieConsentEventListener )
businessEventSource.register( ga4EcommerceListener )
if (!isCordova()) {
  businessEventSource.register( plausibleHandler )
}
businessEventSource.register((evt: any) =>{
  console.log("[TREKKER] [BusinessEventSource] event", evt)
})


const availableLanguages = require('resources/languages.json');
const omittedExperienceFields = [
  'description_manual_translated',
  'photos',
  'description',
  'description_auto_translated',
  'description_translated',
  'hosts',
];

export function cleanExperience(experience) {
  return omit(experience, omittedExperienceFields);
}

export function path2GACategory(fullPathname) {
  let pathname = fullPathname;
  const parts = fullPathname.split('/').filter(x => !!x);
  if (availableLanguages.includes(parts[0])) {
    parts.splice(0, 1);
    pathname = '/' + parts.join('/');
  }

  switch (pathname) {
    case '/':
      return 'Homepage';
    case '/messages':
      return 'Messages';
    case '/schedule':
      return 'Host agenda';
    case '/action':
      return 'Actions';
    case '/login':
      return 'Log in';
    case '/signup':
      return 'Sign up';
    case '/more':
      return 'Settings';
    case '/host/home':
      return 'Host homepage';
    default:
      if (pathname.includes('manage/review')) {
        return 'Review page';
      }
      if (pathname.includes('newoffer')) {
        return 'Create new offer';
      }
      if (pathname.includes('offer')) {
        return 'Create offer';
      }
      if (parts[0] === 'booking') {
        if (parts[2] === 'bookingdetails') {
          return 'Checkout page Details';
        }
        if (parts[2] === 'payment') {
          return 'Checkout page Payment';
        }
        return 'Checkout page';
      }
      if (parts[0] === 'confirmation') {
        return 'Confirmation page';
      }
      if (parts[0] === 'experiences' && parts.length > 1) {
        return `SEO Friendly landing page`;
      }
      if (parts[0] === 's' && parts.length > 1) {
        return `Search page`;
      }
      if (parts[0] === 'experience' && parts.length > 1) {

        if (parts.includes('locals')) {
          return 'Local picker page';
        }

        return `Experience page`;
      }

      if (parts[0] === 'overview') {
        return 'Overview page';
      }

      if (parts[0] === 'personalize' && parts.length > 1) {
        return `Po flow`;
      }

      return 'App';
  }
}

interface AnalyticsList {
  list: string;
  experienceList: ExperienceSource[];
}

export const viewedList$ = new Subject<AnalyticsList>();

viewedList$
  .filter(page => page.experienceList.length > 0)
  .distinctUntilChanged((page1, page2) => {
    return isEqual(page1.experienceList, page2.experienceList);
  })
  .subscribe((page) => {
    console.log('Analytics, viewedList', page);
    Analytics.viewedList(page.experienceList, page.list);
  });

export const viewedExperience$ = new Subject<ExperienceSource>();

viewedExperience$
  .filter(experience => experience && !!experience.id)
  .distinctUntilChanged((experience1, experience2) => experience1.id === experience2.id)
  .subscribe((experience) => {
    console.log('Analytics, viewedExperience', experience);
    Analytics.viewedExperience(experience);
  });

declare const window: WlWindow;
export function analyticsTrack(
  newAnalyticsArgs: EventParams,
  oldAnalyticsArgs: { category?: string; action: string; label: string; value?: any }
) {
  Analytics.track(
    oldAnalyticsArgs.category || window.currentPageCategory,
    oldAnalyticsArgs.action,
    oldAnalyticsArgs.label,
    oldAnalyticsArgs.value
  );
}
